/* import __COLOCATED_TEMPLATE__ from './sunshine-setup-sidedrawer.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type ZendeskConfiguration from 'embercom/models/standalone/zendesk-configuration';

export interface Args {
  isOpen: boolean;
  onClose: () => void;
  closeOnSave: () => void;
}

interface Signature {
  Args: Args;
}

export default class SunshineSetupSidedrawer extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get zendeskConfig(): ZendeskConfiguration | undefined {
    return this.finStandaloneService.zendeskConfig;
  }

  get sunshineConfig() {
    return this.zendeskConfig?.sunshineIntegration;
  }

  get shouldShowOAuthInstructions() {
    return (
      this.zendeskConfig?.shouldShowSunshineOAuthUI &&
      this.sunshineConfig?.isSunshineConnected &&
      this.sunshineConfig?.usesOauth
    );
  }

  get zendeskMarketplaceBotsUrl() {
    if (!this.zendeskConfig?.subdomain) {
      return '#';
    }
    return `https://${this.zendeskConfig.subdomain}.zendesk.com/admin/ai/ai-agents/ai-agents/marketplace-bots`;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Common::SunshineSetupSidedrawer': typeof SunshineSetupSidedrawer;
    'standalone/zendesk/deploy/common/sunshine-setup-sidedrawer': typeof SunshineSetupSidedrawer;
  }
}
